import React, { Component } from 'react';
import { connect } from 'react-redux';

import { makeGetCurrentTeam } from '../selectors/teams';
import { makeGetTeamMessageNotifications } from '../selectors/notifications';

import IconExpand from '../icons/icon-expand';

class ChatToggle extends Component {
    handleShowClick = () => {
        if (this.props.widgetOpen) {
            this.props.dispatch({ type: 'TEAMCHAT_WIDGET_CLOSE_REQUESTED' });
        } else {
            this.props.dispatch({ type: 'TEAMCHAT_WIDGET_OPEN_REQUESTED' });
        }
    }

    render() {
        if (!this.props.team || this.props.team.chat_disabled) {
            return null;
        }

        return (
            <div className="chat-toggle-panel">
                <button className="btn chat-toggle-btn" onClick={this.handleShowClick}>
                    <span>
                        <i className="status-indicator active" />

                        Team Chat

                        {
                            this.props.notificationsCount ? (
                                <span className="notification-bubble">{this.props.notificationsCount}</span>
                            ) : null
                        }
                    </span>

                    <IconExpand />
                </button>
            </div>
        )
    }
}

const makeMapStateToProps = () => {
    const getCurrentTeam = makeGetCurrentTeam();
    const getTeamMessageNotifications = makeGetTeamMessageNotifications();

    return ({ teams, notifications, teamChat }) => ({
        team: getCurrentTeam(teams),
        notificationsCount: getTeamMessageNotifications(notifications.items).length,
        widgetOpen: teamChat.widgetOpen
    })
}

export default connect(makeMapStateToProps)(ChatToggle);
